import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "../../i18n/TranslationProvider";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Sallie from "../UIComponents/Sallie";
import SubmitButton from "../UIComponents/SubmitButton";

const Register = ({ setUser, user }) => {
  const { t } = useTranslation();

  useEffect(() => {
    user.isVerified = true;
    setUser(user);
  }, []);

  const history = useHistory();
  const handleClick = () => { history.push("/"); };

  return (
    <Row>
      <Col>
        <Sallie text={t("starttracking.sallie")} />
        <SubmitButton type="button" onClick={handleClick}>
          {t("starttracking.go_to_dashboard")}
        </SubmitButton>
      </Col>
    </Row>
  );
};

export default Register;